<template>
  <div class="home container-global">
    <div class="title">
      <h2>Aide à la prescription de contraceptifs</h2>
    </div>
    <div class="links">
      <router-link @click="toggleArrow()" to="/algroprescriptions">
        <p>Algorithme de prescription</p>
        <div class="next"><img src="@/assets/images/arrow.svg" /></div>
      </router-link>
      <router-link @click="toggleArrow()" to="/switchcontraceptions">
        <p>Switch contraception</p>
        <div class="next"><img src="@/assets/images/arrow.svg" /></div>
      </router-link>
      <router-link @click="toggleArrow()" to="/fichesinformations">
        <p>Fiches informations</p>
        <div class="next"><img src="@/assets/images/arrow.svg" /></div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "Home",
  components: {},
  methods: {
    ...mapActions("Algo1Module", ["arrowFunction"]),
    toggleArrow() {
      this.arrowFunction();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/scss/variables/colors.scss";

.footer {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #707070;
  letter-spacing: 0;
  font-size: 14px;
  gap: 0.5em;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 10px;
  text-align: center;

  .logo {
    width: 6em;
    height: auto;
    margin-bottom: 1em;
  }
}

.home {
  position: relative;
  margin-top: 37px;
  min-height: calc(100vh - 127px);
  .title {
    text-align: left;
  }
  .links {
    display: flex;
    flex-direction: column;
    margin-top: 40px;
    a {
      display: flex;
      align-items: center;
      justify-content: space-between;
      text-align: left;
      width: 100%;
      height: 62px;
      margin-bottom: 15px;
      border-radius: 7px;
      color: $black-aigm;
      background-color: $light-pink;
      box-shadow: 0px 1px 4px #56090f2b;
    }
    p {
      font-weight: 500;
      letter-spacing: 0px;
      margin-left: 10px;
    }
  }
}
</style>
